/**
 * not-found-page
 *
 * This is the page we show when the user visits a url that doesn't have a route
 */

import React from 'react'
import { H1 } from '../../components/common/text'

const NotFound = () => (
  <article>
    <H1>
      Page not found.
    </H1>
  </article>
)

export default NotFound



// WEBPACK FOOTER //
// ./src/pages/not-found-page/index.js